import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import styles from './ResultsContainer.css';
import withWidth from '@material-ui/core/withWidth';
import {
    Tooltip,
	GridList,
	GridListTile,
	Typography
} from '@material-ui/core';
import {FadeLoader} from 'react-spinners';
import {JOB_STATUS_SUBMITTED, JOB_STATUS_STARTED} from '../../../constants';

function ResultsContainer(props) {

	const {classes, results, loading, displayLightBox, jobStatus, timestamp} = props;

	let resultsMessage;
	switch (jobStatus) {
		case JOB_STATUS_STARTED:
			resultsMessage = 'Processing your images...';
			break;
		case JOB_STATUS_SUBMITTED:
			resultsMessage = 'Your images are in queue...';
			break;
		default:
			resultsMessage = 'Your images are in queue...';
			break;
	}

	let timeString = timestamp ? timestamp: '';

	return (
		<div className={classes.ResultsContainer}>

			<div className={classes.resultsRoot}>
				<div className={classes.gridListRoot}>
					{loading
						? (
						<div className={classes.loading}>
							<div>
								<FadeLoader loading={true}
									color='#1565c0'
								/>
							</div>
							<Typography variant='body1' component='div'>
								{resultsMessage}
							</Typography>
							<Typography variant='body1' component='div'>
								Last request to server:{" "}
								{timeString}
							</Typography>
						</div>
						)
						: (
							<GridList cellHeight={160} cols={5} rows={2} classes={{root:classes.gridListRoot}}>
								{
									results.map( (image, index) => (
										<Tooltip title={image.name} placement="top" key={index} classes={{tooltip: classes.tooltip}}>
											<GridListTile 
												onClick={()=>displayLightBox(index)} 
												rows={1} 
												cols={1}
												className={classes.imageTile2}
											>
												<img src={image.src} alt={image.name} className={classes.preview2}></img>
											</GridListTile>
										</Tooltip>
									))
								}
							</GridList>
						)
					}
				</div>    
			</div>
		</div>
	);
}

export default withStyles(styles, {withTheme: true})(withWidth()(ResultsContainer));
